// @flow
import type { Activity, ActivityPayload } from '@activity/types';

export const parseActivity = (activity: ActivityPayload): Activity => ({
  id: activity.id,
  name: activity.name,
  photo: `activity-${ activity.photo }.png`,
  indicativePrice: activity.indicativePrice,
});
